<template>
  <div id="user-list">
    <!-- list filters -->
    <v-card>
      <v-card-text>
        <CRUDTable
          ref="CRUDTableRef"
          :external-loading="loading"
          :remote-create-item="createItem"
          :remote-update-item="updateItem"
          :remote-delete-item="deleteItem"
          :remote-get-item="getItem"
          :fetch-list="fetchList"
          edit-with="1000px"
          :create-params-callback="createParamsCallback"
          :form-config="formConfig"
          :enable-search="false"
          :input-configs="inputConfigs"
          @reset="handleReset"
          @openEditDialog="onEditDialog"
        >
          <template v-slot:extra-top>
            <v-card elevation="0">
              <v-card-text>
                <v-row>
                  <v-col cols="3">
                    <universal-input
                      v-model="commissionSchemaTypeFilter"
                      :config="commissionSchemaTypeConfig"
                    >
                    </universal-input>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </template>
        </CRUDTable>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { createItem, deleteItem, fetchList, getItem, updateItem } from '@/api/commissionSchema'
import CRUDTable from '@/components/CRUD/CRUDTable'
import { fetchList as fetchSchemaType } from '@/api/commissionSchemaType'
import UniversalInput from '@/components/CRUD/UniversalInput.vue'

const CRUDTableRef = ref(null)

const commissionSchemaTypeFilter = ref(-1)

function handleReset() {
  console.log('handleReset')
}
function onEditDialog(action) {
  console.log('action', action)
}
const loading = ref(false)
const searchKeyWord = ref('')

const commissionSchemaTypeList = ref([])
const commissionSchemaTypeConfig = ref({
  name: 'commissionSchemaTypeFilter',
  label: 'Commission Schema Type',
  type: {
    name: 'autocomplete',
    items: commissionSchemaTypeList.value,
  } })

const formConfig = ref({
  title: 'Commission Schema',
  headers: [
    { value: 'id', text: 'id' },
    { value: 'commissionSchemaTypeID', text: 'Type' },

    // { value: 'commissionPlan', text: 'Commission Plan' },
    { value: 'rate', text: 'Rate' },
    { value: 'amount', text: 'Amount' },
    { value: 'fromCourseTotal', text: 'From Course Total' },
    { value: 'toCourseTotal', text: 'To Course Total' },
    { value: 'fromSalesTarget', text: 'From Sales Target' },
    { value: 'toSalesTarget', text: 'To Sales Target' },
    { value: 'maximumLimit', text: 'Maximum Limit' },
    { value: 'actions', text: 'Actions', sortable: false },
  ],
  customColumns: [
    {
      name: 'commissionSchemaTypeID',
      callback(commissionSchemaTypeID) {
        // console.log('commissionSchemaTypeID', commissionSchemaTypeID)
        for (let index = 0; index < commissionSchemaTypeList.value.length; index += 1) {
          const commissionSchemaType = commissionSchemaTypeList.value[index]

          // console.log('commissionSchemaType.id === commissionSchemaTypeID', commissionSchemaType.id, commissionSchemaTypeID)
          // console.log('commissionSchemaType', commissionSchemaType)
          if (commissionSchemaType.id === commissionSchemaTypeID) {
            return commissionSchemaType.name
          }
        }

        return ''
      },
    },
  ],
})

const inputConfigs = ref([
  {
    md: 12,
    propName: 'commissionSchemaTypeID',
    label: 'Schema Type',

    type: {
      name: 'select',
      items: commissionSchemaTypeList.value,
    },
  },

  // { md: 6, propName: 'commissionPlan', label: 'Commission Plan' },
  { md: 6, propName: 'rate', label: 'Rate', defaultValue: 0, type: { inputType: 'number', min: 0 } },
  { md: 6, propName: 'amount', label: 'Amount', defaultValue: 0, type: { inputType: 'number', min: 0 } },
  { md: 6, propName: 'fromCourseTotal', label: 'From Course Total', defaultValue: 0, type: { inputType: 'number', min: 0 } },
  { md: 6, propName: 'toCourseTotal', label: 'To Course Total', defaultValue: 0, type: { inputType: 'number', min: 0 } },
  { md: 6, propName: 'fromSalesTarget', label: 'From Sales Target', defaultValue: 0, type: { inputType: 'number', min: 0 } },
  { md: 6, propName: 'toSalesTarget', label: 'To Sales Target', defaultValue: 0, type: { inputType: 'number', min: 0 } },
  { md: 6, propName: 'maximumLimit', label: 'Maximum Limit', defaultValue: 0, type: { inputType: 'number', min: 0 } },
])

function createParamsCallback(params) {
  const parameters = params

  // params.centerList = selectedCenterList.value
  // params.courseList = selectedCourseList.value
  // parameters.sysRoleList = checkboxSysRoleList.value

  // parameters.centerList = checkboxCenterList.value
  parameters.commissionSchemaTypeId = commissionSchemaTypeFilter.value

  // console.log('params.centerList', params.centerList)

  return parameters
}

watch(commissionSchemaTypeFilter, newValue => {
  console.log('commissionSchemaTypeFilter', newValue)
  CRUDTableRef.value.fetchData()
})

onMounted(() => {
  fetchSchemaType({
    page: 0,
    limit: 0,
  }).then(res => {
    const { items } = res.data
    for (let index = 0; index < items.length; index += 1) {
      const item = items[index]
      commissionSchemaTypeList.value.push({
        ...item,
        label: item.name,
      })
    }
  })
})
</script>
